import { render, staticRenderFns } from "./goal_add.vue?vue&type=template&id=492f3818&scoped=true&"
import script from "./goal_add.vue?vue&type=script&lang=js&"
export * from "./goal_add.vue?vue&type=script&lang=js&"
import style0 from "./goal_add.vue?vue&type=style&index=0&id=492f3818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f3818",
  null
  
)

export default component.exports